const Styles = {
  primary: {
    main: "#20ad94",
  },
  secondary: {
    main: "#167967",
  },
  fontSizes: {
    small: "clamp(0.6rem, 0.8vw, 0.8rem)",
    medium: "clamp(0.8rem, qvw, qrem)",
    large: "clamp(1rem, 1.2vw, 1.2rem)",
  },
  Header: {
    sx: {
      height: "auto",
      p: 3,
      borderRadius: 0,
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      borderBottom: {
        xs: "1px solid rgba(255, 255, 255, 0.1)",
        lg: "1px solid rgba(0, 0, 0, 0.1)",
      },
      // Also add a blur effect
      backdropFilter: "blur(10px)",
    },
    LogoBox: {
      sx: {
        display: "flex-start",
        justifyContent: "left",
        width: {
          xs: "140px",
          md: "140px",
        },
        paddingLeft: {
          lg: 1,
        },
      },
    },
    Avatar: {
      sx: {
        width: 30,
        height: 30,
        bgcolor: "#20ae94",
        color: "#FFFFFF",
        fontSize: 16,
      },
      Name: {
        sx: {
          color: "#222",
          flexGrow: 1,
          mr: 2,
          display: { xs: "none", md: "block" },
        },
      },
    },
    Menu: {
      sx: {
        width: "100%",
        marginTop: {
          xs: 2,
          md: 0,
        },
        marginLeft: {
          xs: 0,
          md: 4,
        },
        justifyContent: "center",
        display: {
          xs: "block",
          md: "flex",
        },
      },
      Link: {
        sx: {
          color: "#20ae94",
          textDecoration: "none",
          "&:hover": {
            color: "#222",
          },
          marginRight: {
            xs: 0,
            md: 4,
          },
          marginBottom: {
            xs: 2,
            md: 0,
          },
          padding: {
            xs: 1,
            md: 0,
          },
          backgroundColor: {
            xs: "#f9f9f9",
            md: "transparent",
          },
          borderRadius: {
            xs: "5px",
            md: 0,
          },
          display: {
            xs: "block",
            md: "inline-block",
          },
        },
      },
    },
  },
  CreditScoreGauge: {
    veryHighRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#cc0000ff", // Indicates extreme risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    highRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#cc3a00ff", // Indicates high risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    mediumHighRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#cc6d00ff", // Higher than average risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    mediumRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#cca700ff", // Moderate risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    mediumLowRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#00cc44ff", // Slightly below average risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    lowRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#18cc00ff", // Low risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    veryLowRisk: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "#41af01ff", // Very low risk
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
    insufficientInfo: {
      width: 200,
      height: 200,
      fontSize: 38,
      valueFillColor: "grey", // Insufficient information
      referenceFillColor: {
        xs: "rgba(255,255,255,0.3)",
        md: "#f9f9f9"
      },
    },
  },
  Test: {
    heading: {
      backgroundColor: "red",
      padding: 2,
      color: '#fff',
    },
  }
};

export default Styles;
